import { useState, useEffect } from 'react';
import api from '../services/api';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';



export default function ModalAutoDelete({ discussionId, currentValue, onClose, onSaved }) {
  const [selected, setSelected] = useState(currentValue ?? null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
const token = localStorage.getItem("token");
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const { t } = useTranslation();

const getTTLLabel = (value) => {
  if (!value) return t('duree.jamais');
  if (value === 365) return t('duree.an', { count: 1 });
  return t('duree.jour', { count: value });
};

const TTL_OPTIONS = [
  { value: null, icon: 'ti-infinity'      },
  { value: 1,    icon: 'ti-sun'           },
  { value: 7,    icon: 'ti-calendar-week' },
  { value: 30,   icon: 'ti-calendar-month'},
  { value: 90,   icon: 'ti-calendar-time' },
  { value: 365,  icon: 'ti-calendar-stats' },
].map(opt => ({ ...opt, label: getTTLLabel(opt.value) }));

useEffect(() => {
  setSelected(currentValue ?? null);
}, [currentValue]);

  const handleConfirm = async () => {
  setLoading(true);
  setError(null);
  try {
  
    
    const res = await api.put(
      `${API_URL}/api/discussions/${discussionId}/auto-delete`,
      { days: selected },
      { headers: { Authorization: `Bearer ${token}` } }
    );
       
    onSaved(res.data.autoDeleteAfter);
    onClose();
  } catch (e) {
    console.error('❌ erreur:', e.response?.data || e.message);
    setError(t('duree.error'));
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="modalauto-overlay" onClick={onClose}>
      <div className="modalauto-box" onClick={e => e.stopPropagation()}>

        <div className="modalauto-header">
          <i className="ti ti-clock-hour-3" aria-hidden="true" />
          <span>{t('duree.titre')}</span>
        </div>

        <p className="modalauto-desc">
          {t('duree.desc')}
        </p>

        <div className="ttl-options">
  {TTL_OPTIONS.map(opt => (
    <div
      key={opt.value ?? 'null'}
      className={`ttl-option ${selected === opt.value ? 'selected' : ''}`}
      onClick={() => setSelected(opt.value)}
    >
      <div className="ttl-option-left">
        <i className={`ti ${opt.icon} ttl-option-icon`} aria-hidden="true" />
        <span className="ttl-option-label">{opt.label}</span>
      </div>
      <div className="ttl-option-check">
        <i className="ti ti-check" aria-hidden="true" />
      </div>
    </div>
  ))}
</div>

        {error && <p className="modal-error">{error}</p>}

        <div className="modalauto-footer">
          <button className="btn-annul" onClick={onClose} disabled={loading}>{t('modal.annuler')}</button>
          <button className="btn-confirm" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Sauvegarde…' : t('2fa.confirmer')}
          </button>
        </div>

      </div>
    </div>
  );
}